import {
  ChartBarIcon,
  ServerIcon,
  ArrowsRightLeftIcon,
  GlobeAltIcon,
  CalendarDaysIcon
} from '@heroicons/react/24/outline';

export const projects = [
  {
    id: 'ecommerce-performance',
    icon: ChartBarIcon,
    color: 'cyan',
    hasDiagram: true,
    image: '/images/blog/magento-performance.svg',
    thumbnail: '/images/blog/thumb-cs-ecommerce.svg'
  },
  {
    id: 'legacy-rescue',
    icon: ServerIcon,
    color: 'blue',
    hasDiagram: true,
    image: '/images/blog/strangler-fig.svg',
    thumbnail: '/images/blog/thumb-cs-legacy.svg'
  },
  {
    id: 'erp-middleware',
    icon: ArrowsRightLeftIcon,
    color: 'emerald',
    hasDiagram: true,
    image: '/images/blog/erp-integration.svg',
    thumbnail: '/images/blog/thumb-cs-erp.svg'
  },
  {
    id: 'eleberk-website',
    icon: GlobeAltIcon,
    color: 'violet',
    hasDiagram: false,
    image: '/images/blog/eleberk-screenshot.webp',
    imageFit: 'cover',
    liveUrl: 'https://eleberk.ee'
  },
  {
    id: 'suurupi-pilates',
    icon: CalendarDaysIcon,
    color: 'teal',
    hasDiagram: true,
    image: '/images/blog/suurupi-pilates-screenshot.webp',
    imageFit: 'cover',
    liveUrl: 'https://suurupipilates.ee'
  },
];

export const getProjectConfig = (id) => projects.find(p => p.id === id);
